$('.js-popup').magnificPopup({
  type: 'inline',
  closeBtnInside: true,
  focus: '#name',
  fixedContentPos: true,
   callbacks: {
        beforeOpen: function() {
         	$('body').addClass('no-scroll');
        },
        beforeClose: function() {
            $('body').removeClass('no-scroll');
        }
    }
});